module.exports = __webpack_public_path__ + "img/6bcf8a39597c8951b1e88b09bc2036bc.png";